'use client'

/**
 * 案例卡片骨架加载组件
 */
export function CaseCardSkeleton() {
  return (
    <article className="bg-white rounded-lg overflow-hidden border border-gray-100">
      {/* Image Skeleton */}
      <div className="aspect-video bg-gray-200 animate-pulse" />

      {/* Content Area */}
      <div className="p-4">
        {/* Title Skeleton */}
        <div className="h-5 bg-gray-200 rounded animate-pulse mb-2" />
        <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4 mb-4" />

        {/* Description Skeleton */}
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-1.5" />
        <div className="h-4 bg-gray-200 rounded animate-pulse mb-1.5" />
        <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3 mb-4" />

        {/* Tags Skeleton */}
        <div className="flex gap-2">
          <div className="h-6 w-16 bg-gray-200 rounded animate-pulse" />
          <div className="h-6 w-20 bg-gray-200 rounded animate-pulse" />
          <div className="h-6 w-24 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </article>
  )
}
